var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManagerOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64258 8.62387C5.73228 7.767 6.04669 6.9454 6.55689 6.23471C7.06708 5.52402 7.75666 4.94707 8.56215 4.55697C9.36762 4.16687 10.2631 3.97615 11.1663 4.00238C12.0693 4.02861 12.951 4.27094 13.73 4.70706C14.5091 5.14319 15.1605 5.75909 15.6244 6.49808C16.0882 7.23706 16.3496 8.07537 16.3843 8.93586C16.4191 9.79635 16.2263 10.6513 15.8235 11.4222C15.4282 12.1785 14.8434 12.8299 14.121 13.3189",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37695 6.54688C7.2105 7.36704 8.2086 8.01905 9.31187 8.46411C10.4152 8.90918 11.6011 9.13822 12.7992 9.13759C13.9775 9.13871 15.1441 8.91757 16.2318 8.48721",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84522 12.7969C9.54098 12.7969 9.24351 12.8829 8.99045 13.044C8.73742 13.2052 8.54022 13.4342 8.42376 13.7022C8.30731 13.9701 8.27684 14.2649 8.3362 14.5494C8.39557 14.8339 8.54211 15.0952 8.75729 15.3002C8.97247 15.5053 9.24659 15.645 9.54508 15.7016C9.84358 15.7581 10.1529 15.7291 10.4341 15.6181C10.7153 15.5072 10.9555 15.3192 11.1245 15.078C11.2937 14.8369 11.3838 14.5533 11.3838 14.2633C11.3838 13.8744 11.2218 13.5014 10.9332 13.2264C10.6447 12.9514 10.2534 12.7969 9.84522 12.7969Z",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6875 10.2969V11.3508C3.6875 12.1286 4.01171 12.8746 4.5888 13.4246C5.1659 13.9746 5.9486 14.2837 6.76474 14.2837H8.22463",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 23.6956C21.0003 22.4288 20.4981 21.1863 19.5485 20.1036C18.6028 19.0252 17.2494 18.1465 15.6348 17.5625",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 23.6934C0.999795 22.4269 1.50165 21.1847 2.45087 20.102C3.39534 19.0248 4.74668 18.1468 6.35884 17.5626",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3342 3.6671C26.3342 1.64182 24.6924 0 22.6671 0C20.6418 0 19 1.64182 19 3.6671C19 5.69238 20.6418 7.3342 22.6671 7.3342C24.6924 7.3342 26.3342 5.69238 26.3342 3.6671Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerOpen);
export default __webpack_public_path__ + "static/media/manager-open.22e6032e5f1f77f219a364088b214431.svg";
export { ForwardRef as ReactComponent };